import { strikethrough as strikethrough_1 } from './strikethrough.locstring.json';
import loc from 'owa-localize';
import RibbonButton, { RibbonButtonState } from './RibbonButton';

import { toggleStrikethrough } from 'roosterjs-editor-api';

const strikethrough: RibbonButton = {
    key: 'strikethrough',
    title: () => loc(strikethrough_1),
    imageSrc: require('../svg/strikethrough.svg'),
    buttonState: formatState =>
        formatState.isStrikeThrough ? RibbonButtonState.Checked : RibbonButtonState.Normal,
    onExecute: plugin => toggleStrikethrough(plugin.getEditor()),
};

export default strikethrough;
